import Marquee from "react-fast-marquee";
import Reveal from "../components/Reveal";
import { JournalEntryRow } from "../components/journal/JournalEntryRow";
import { JournalCta } from "../components/journal/JournalCta";
import { Seo } from "../components/Seo";
import { useT } from "../i18n/I18nProvider";

export default function Journal() {
  const t = useT();
  const entries = t("journal.entries");
  const tags = t("journal.tags");
  const readLabel = t("journal.readTimeLabel");
  const readUnit = t("journal.readTimeUnit");

  return (
    <>
      <Seo page="journal" />
      {/* HEADER */}
      <section className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pt-16 md:pt-24 pb-12 md:pb-16">
        <Reveal>
          <div className="overline mb-4 md:mb-6">
            {t("journal.header.overline")}
          </div>
        </Reveal>
        <Reveal delay={80}>
          <h1 className="font-display text-5xl sm:text-7xl md:text-8xl lg:text-[9vw] leading-[0.92] tracking-tightest max-w-[14ch]">
            {t("journal.header.title1")}
            <br />
            <span className="font-editorial text-ink-700">
              {t("journal.header.titleEditorial")}
            </span>
            {t("journal.header.titleEnd")}
          </h1>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-6 md:mt-8 text-[15px] md:text-[16px] text-ink-500 max-w-2xl leading-relaxed">
            {t("journal.header.paragraph")}
          </p>
        </Reveal>
      </section>

      {/* TAG MARQUEE */}
      <section className="border-y border-ink-200 py-4 md:py-5 bg-white/60">
        <Marquee gradient={false} speed={30} pauseOnHover>
          {tags.concat(tags).map((tag, i) => (
            <div
              key={`${tag}-${i}`}
              className="flex items-center gap-5 md:gap-6 pr-5 md:pr-6"
            >
              <span className="overline">{tag}</span>
              <span className="w-1 h-1 rounded-full bg-ink-300" />
            </div>
          ))}
        </Marquee>
      </section>

      {/* EDITORIAL LIST */}
      <section
        className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-14 md:py-20"
        data-testid="journal-list"
      >
        <ul className="divide-y divide-ink-200">
          {entries.map((e, i) => (
            <JournalEntryRow
              key={e.slug}
              entry={e}
              index={i}
              readLabel={readLabel}
              readUnit={readUnit}
            />
          ))}
        </ul>
      </section>

      {/* CTA */}
      <JournalCta />
    </>
  );
}
